import { ActionContext } from 'vuex';

import { PropertyTypeNumber } from '@/models/valuationFunnel';
import { PropertyType } from '@/types';

import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { PropertyDetails } from '@/models/queries/getPropertyDetails';
import {
  PropertyValuationActions,
  PropertyValuationActionsType,
  PropertyValuationData,
  PropertyValuationGetters,
  PropertyValuationModule,
  PropertyValuationMutations,
  PropertyValuationState,
} from './types';

const state = (): PropertyValuationState => ({
  step: 0,
  totalSteps: 0,
  previousStep: 0,
  loading: false,
  data: {
    propertyType: undefined,
    offerType: undefined,
    address: {
      lat: 0,
      lon: 0,
      countryCode: 'CH',
      postalCode: '',
      city: '',
      street: '',
      formattedAddress: '',
    },
    livingSpace: undefined,
    lotSize: undefined,
    rooms: 0,
    buildYear: undefined,
    isRenovated: undefined,
    renovationYear: undefined,
    isPropertyOwner: undefined,
    email: '',
    name: '',
    phoneNumber: '',
    whenToSell: undefined,
    culture: 'en-CH',
    leadId: undefined,
    estimationReason: '',
    utmSource: undefined,
    utmMedium: undefined,
    utmCampaign: undefined,
  },
  lead: {
    homegate_lead_id: '',
    email: '',
    confirm_free_consultation: false,
  },
  propertyDetailsData: [],
  selectedPropertyDetailIndex: 0,
  locationAlternatives: [],
  isIframeActive: false,
});

const mutations: PropertyValuationMutations = {
  setFormStep(state: PropertyValuationState, payload: { step: number }): void {
    state.previousStep = state.step;
    state.step = payload.step;
  },
  setFormData(state: PropertyValuationState, payload: PropertyValuationData): void {
    state.data = { ...state.data, ...payload };
  },
  setPropertyDetailsData(
    state: PropertyValuationState,
    PropertyDetails: Array<PropertyDetails>,
  ): void {
    state.propertyDetailsData = PropertyDetails;
  },
  setSelectedPropertyDetailIndex(
    state: PropertyValuationState,
    selectedPropertyDetailIndex: number,
  ): void {
    state.selectedPropertyDetailIndex = selectedPropertyDetailIndex;
  },
  setIframeActive(state: PropertyValuationState, isIframeActive: boolean) {
    state.isIframeActive = isIframeActive;
  },
};

const getters: PropertyValuationGetters = {
  isIv24FunnelActive: (state: PropertyValuationState): boolean =>
    isPlatformIs24() && state.isIframeActive,
};

const actions: PropertyValuationActions = {
  setFormData(context: ActionContext<PropertyValuationState, any>, payload: PropertyValuationData) {
    context.commit('setFormData', payload);
  },

  setFormStep(context: ActionContext<PropertyValuationState, any>, payload: { step: number }) {
    context.commit('setFormStep', { step: payload.step });
  },

  initData(context: ActionContext<PropertyValuationState, any>, type: PropertyType) {
    context.commit('setFormData', {
      propertyType:
        type === PropertyType.Apartment ? PropertyTypeNumber.Apartment : PropertyTypeNumber.House,
    });
    context.commit('setFormStep', { step: 1 });
  },
};

export const propertyValuationModuleNameSpace = (action: string): string => {
  return `propertyValuation/${action}`;
};

const propertyValuationActions: PropertyValuationActionsType =
  Object.keys({
    ...actions,
    ...getters,
  }).reduce(
    (p, c) => ({
      ...p,
      [c]: propertyValuationModuleNameSpace(c),
    }),
    {},
  ) || {};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
} as PropertyValuationModule;
export { propertyValuationActions };
